import { Link } from "react-router-dom";
import { getEntryById } from "@/utils/content";
import type { SpecialArticle } from "@/types/content";

export default function SpecialArticles({ articles }: { articles: SpecialArticle[] }) {
  if (articles.length === 0) return null;

  return (
    <section className="mt-12">
      <h2 className="font-heading text-2xl text-foreground-950 tracking-wide">专题内文章</h2>
      <div className="mt-5 flex flex-col gap-3">
        {articles.map((article) => {
          const exists = getEntryById(article.id);
          const to = exists ? `/detail/${article.id}` : "/news";
          return (
            <Link
              key={article.id}
              to={to}
              className="group flex items-start gap-4 rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 shrink-0 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className="ri-article-line text-lg" />
              </span>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2">
                  {article.summary}
                </p>
              </div>
              <i className="ri-arrow-right-line text-foreground-400 ml-auto mt-2 shrink-0 group-hover:text-primary-500 transition-colors" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}